module.exports = __webpack_public_path__ + "img/banker-gold-promotions.1ea7f1fb.png";